import * as React from 'react';
import { Body2, Link } from '@cian/ui-kit';

import { getNewbuildingIdFromUrl } from '../shared/getNewbuildingIdFromUrl';
import { trackNavigationToListingJK } from '../shared/tracking';
import { ILinkCell } from '../../../../../../types/newbuildingsCompare';
import * as style from './style.css';

export interface ILinkCellProps {
  cell: ILinkCell;
  isFlatsBlock?: boolean;
}

export const LinkCell = ({ cell, isFlatsBlock }: ILinkCellProps): React.JSX.Element => {
  const { data } = cell;

  const handleClick = React.useCallback(() => {
    if (!data || !isFlatsBlock) {
      return;
    }

    const id = getNewbuildingIdFromUrl(data.url);

    if (id) {
      trackNavigationToListingJK(id);
    }
  }, [data, isFlatsBlock]);

  if (!data) {
    return (
      <div className={style['container']}>
        <Body2 color="text-primary-disabled">{cell.state.text ?? ''}</Body2>
      </div>
    );
  }

  return (
    <div className={style['container']}>
      <Link href={data.url} target="_blank" fontSize="M" fontWeight="bold" onClick={handleClick} spacingSize="M">
        {data.text}
      </Link>
    </div>
  );
};
